import { Link } from "gatsby";
import tw, { styled } from "twin.macro";

import freeBadgeSrc from "../../../assets/images/solutions/free-badge.svg";
import SvgObject from "../../elements/SvgObject";
import ConvertIcon from "../../icons/ConvertIcon";
import CustomerPortalIcon from "../../icons/CustomerPortalIcon";
import ReactivateIcon from "../../icons/ReactivateIcon";
import RetainIcon from "../../icons/RetainIcon";

const Solution = styled(Link)`
  ${tw`relative flex flex-col flex-grow basis-1/3 p-[14px] pl-[44px] rounded-[14px]`}
  gap: 5px;

  transition: all 0.15s ease-out;

  &:hover {
    text-decoration: none;
    transform: scale(1.02);

    .solutions-link-free-badge {
      transform: scale(1.1);
    }
  }
`;

const Retain = styled(Solution)`
  border: 1px solid #e9d5ff;
  background: linear-gradient(90deg, #fff 0%, #fbf7ff 100%);
  box-shadow: 0px 0px 10px 0px rgba(180, 109, 247, 0.07);
`;

const Convert = styled(Solution)`
  border: 1px solid #67e8f9;
  background: linear-gradient(90deg, #fff 0%, #e8f9ff 100%);
  box-shadow: 0px 0px 10px 0px rgba(8, 145, 178, 0.07);
`;

const Reactivate = styled(Solution)`
  border: 1px solid #fbcfe8;
  background: linear-gradient(90deg, #fff 20.94%, #fff2f8 99.96%);
  box-shadow: 0px 0px 10px 0px rgba(219, 39, 120, 0.07);
`;

const CustomerPortal = styled(Solution)`
  border: 1px solid #fad9ae;
  background: linear-gradient(90deg, #fff 20.94%, #fff6ed 99.96%);
  box-shadow: 0px 0px 10px 0px rgba(242, 153, 74, 0.07);
`;

const Icon = styled.div`
  ${tw`absolute w-[24px] h-[24px] text-[24px] leading-[24px]`}
  top: 8px;
  left: 14px;
`;

const Title = styled.div`
  ${tw`font-title font-semibold text-[16px] leading-[16px]`}
`;

const Desc = styled.div`
  ${tw`font-title text-[12px] leading-[14px]`}
  color: #75808F;
`;

const FreeBadge = styled(SvgObject)`
  ${tw`absolute -top-[8px] right-2 w-[37px] h-[17px]`}
  transition: all 0.15s ease-out;
`;

export const RetainLink: React.FunctionComponent = () => (
  <Retain to="/solutions/retain/">
    <Icon tw="text-retain">
      <RetainIcon />
    </Icon>
    <Title tw="text-retain">Retain</Title>
    <Desc>Cancellation flows</Desc>
  </Retain>
);

export const ConvertLink: React.FunctionComponent = () => (
  <Convert to="/solutions/convert/">
    <Icon tw="text-convert">
      <ConvertIcon />
    </Icon>
    <Title tw="text-convert">Convert</Title>
    <Desc>Conversion incentives</Desc>
  </Convert>
);

export const ReactivateLink: React.FunctionComponent = () => (
  <Reactivate to="/solutions/reactivate/">
    <Icon tw="text-reactivate">
      <ReactivateIcon />
    </Icon>
    <Title tw="text-reactivate">Reactivate</Title>
    <Desc>Winback campaigns</Desc>
  </Reactivate>
);

export const CustomerPortalLink: React.FunctionComponent = () => (
  <CustomerPortal to="/solutions/customer-portal/">
    <FreeBadge
      data={freeBadgeSrc}
      width={54}
      height={54}
      className="solutions-link-free-badge"
    />
    <Icon tw="text-customer-portal">
      <CustomerPortalIcon />
    </Icon>
    <Title tw="text-customer-portal">Customer Portal</Title>
    <Desc>Customer billing UX</Desc>
  </CustomerPortal>
);
